import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=53ef9d12&scoped=true"
var script = {}
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=53ef9d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ef9d12",
  null
  
)

export default component.exports